import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import { useCallback } from 'react';
import AgGridTable from 'src/app/main/utilities/AgGridTable';
import moment from "moment";
import FuseSvgIcon from '@fuse/core/FuseSvgIcon/FuseSvgIcon';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
import { useParams } from 'react-router-dom';
import uploadSingleFilePopup from '../upload-component/uploadSingleFilePopup';
import CustomDatePicker from 'src/app/main/utilities/CustomDatePicker';



/* -------------------------------- expiryDate -------------------------------- */
// const expiryDate = forwardRef((props, ref) => {
//     const refDatePicker = useRef();
//     const [expiryDate, setExpiryDate] = useState(null);

//     const handleExpiryDateChange = (newValue) => {
//         setExpiryDate(newValue);
//     };

//     useEffect(() => {
//         if (props.data.expiryDate) {
//             setExpiryDate(props.data.expiryDate);
//         }
//     }, [props.data])

//     useImperativeHandle(ref, () => {
//         return {
//             getValue() {
//                 if (expiryDate !== null) {
//                     return moment(expiryDate).format('YYYY-MM-DD');

//                 }
//             }
//         };
//     });

//     return (
//         <CustomDatePicker
//             format={'yyyy-MM-dd'}
//             name={'expiryDate'}
//             value={expiryDate ? expiryDate : (!props.value ? null : props.value)}
//             handleChange={handleExpiryDateChange}
//             ref={refDatePicker}
//         />
//     );
// });
const startDate = forwardRef((props, ref) => {
    const refEndDatePicker = useRef();
    const [startDate, setStartDate] = useState(null);

    const handleStartDateChange = (newValue) => {
        setStartDate(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {
        if (props.data.startDate) {
            setStartDate(props.data.startDate);
        }
    }, [props.data])

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (startDate !== null) {
                    return moment(startDate).format('YYYY-MM-DD');

                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'startDate'}
            value={startDate ? startDate : (!props.value ? null : props.value)}
            handleChange={handleStartDateChange}
            ref={refEndDatePicker}
        />
    );
});
const endDate = forwardRef((props, ref) => {
    const refStartDatePicker = useRef();
    const [endDate, setEndDate] = useState(null);

    const handleEndDateChange = (newValue) => {
        setEndDate(moment(newValue).format('YYYY-MM-DD'));
    };

    useEffect(() => {
        if (props.data.endDate) {
            setEndDate(props.data.endDate);
        }
    }, [props.data])

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (endDate !== null) {
                    return moment(endDate).format('YYYY-MM-DD');

                }
            }
        };
    });

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={'endDate'}
            value={endDate ? endDate : (!props.value ? null : props.value)}
            handleChange={handleEndDateChange}
            ref={refStartDatePicker}
        />
    );
});

const educationdata = [
    { eductionalAttainment: "Master Degree", University: "", type: "", expiryDate: "", attachFile: "" },
]

const eductionalAttainment = ["Master's Degree", "Bachelor's Degree", "Professional Degree"]

const EductionDetail = ({ personalInfo, setSnackState, setSuccessMsg }) => {

    const url = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.educationDocInfoes}`

    const gridRef = useRef();
    const params = useParams();
    const [gridApi, setGridApi] = useState(null);
    const [uploadDocument, setUploadDocument] = useState([])
    const [educationInfo, setEducationInfo] = useState([]);

    const handleDateFormat = (props) => {
        return props.value && moment(props.value).format('DD-MM-YYYY')
    }

    const [educationColumnDefs, setEducationColumnDefs] = useState([
        { field: 'file', enableRowGroup: false, hide: true, editable: false },
        {
            field: 'eductionalAttainment', enableRowGroup: true, cellEditor: 'agSelectCellEditor', cellEditorParams: {
                values: eductionalAttainment,
            }
        },
        { field: 'university', enableRowGroup: true, headerName: 'School/University/Institute' },
        { field: 'documentType', enableRowGroup: true, },
        // { field: 'expiryDate', enableRowGroup: true, cellEditor: expiryDate },
        { field: 'startDate', cellEditor: startDate, cellRenderer : handleDateFormat  },
        { field: 'endDate', cellEditor: endDate, cellRenderer : handleDateFormat  },
        {
            field: 'uploadFile', enableRowGroup: true, cellEditor: uploadSingleFilePopup, cellStyle: {
                textAlign: 'right',
            }
        }
    ]);

    const onGridReady = useCallback((params) => {
        setGridApi(params);
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, [educationInfo]);


    const getEducationDoc = async () => {
        try {
            const documentInfoesList = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
            const eductionDocuments = documentInfoesList.data?._embedded?.educationDocInfoes;
            const document = eductionDocuments.filter((doc) => doc.empId == personalInfo.employeeId);
            if (document.length > 0) {
                setEducationInfo(document);
            }

        } catch (error) {
            // setError(error.message);
        }
    }

    useEffect(() => {
        if (params.id) {
            getEducationDoc();
        }
    }, [params.id, personalInfo]);


    /*------------------------------Inline Row editing options-------------------------------*/

    const onBtAdd = useCallback((event) => {
        const newRow = {}
        const newRowDate = gridRef.current.api.applyTransaction({ add: [newRow] });
        const RowIndex = newRowDate.add[0].rowIndex;
        // educationInfo.splice(RowIndex, 0, newRow);
        gridRef.current.api.refreshCells();

        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'eductionalAttainment')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'eductionalAttainment',
            });
        }, 800);
    }, []);
    const onBtStartEditing = useCallback((event) => {
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'eductionalAttainment')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'eductionalAttainment',
        });
    }, []);

    // const onBtCopyRow = useCallback((event) => {
    // }, []);

    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        educationInfo.splice(event.node.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
        selectedRow.map(async (row) => {
            await OAuthService.deleteData(url, row.id);
        })
    }, [gridApi, educationInfo])

    const getContextMenuItems = (event) => {
        var result = [
            {
                name: "Add Row",
                icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                action: () => {
                    onBtAdd(event);
                },
            },
            {
                name: "Edit Row",
                icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                action: () => {
                    onBtStartEditing(event);
                },
            },
            // {
            //     name: "Copy Row",
            //     icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
            //     action: () => {
            //         onBtCopyRow(event);
            //     },
            // },
            {
                name: "Delete Row",
                disabled: event.node === null ? true : false,
                icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                action: () => {
                    onBtDeleteRow(event);
                },
            },
        ];
        return result;
    };

    const onRowValueChanged = useCallback(async (event) => {
        const { data } = event.node;
        const model = {
            id: data.id ? data.id : "",
            eductionalAttainment: data.eductionalAttainment,
            university: data.university,
            documentType: data.documentType,
            // expiryDate: data.expiryDate,
            startDate: data.startDate,
            endDate: data.endDate,
            empId: params.id ? params.id : personalInfo.employeeId,
            file: data.file,
            rowIndex: event.node.rowIndex
        }
        if (params.id) {
            if (data.id) {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.id === event.node.data.id) {
                            item.eductionalAttainment = data.eductionalAttainment;
                            item.university = data.university;
                            item.documentType = data.documentType;
                            // item.expiryDate = data.expiryDate;
                            item.startDate = data.startDate,
                                item.endDate = data.endDate,
                                item.empId = personalInfo.employeeId;
                            item.file = data.file;
                        }
                        return item;
                    });
                    setUploadDocument(updatedData);
                } else {
                    setUploadDocument([...uploadDocument, model]);
                }
            } else {
                if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                    const updatedData = uploadDocument.map((item) => {
                        if (item.rowIndex === event.node.rowIndex) {
                            item.eductionalAttainment = data.eductionalAttainment;
                            item.university = data.university;
                            item.documentType = data.documentType;
                            // item.expiryDate = data.expiryDate;
                            item.startDate = data.startDate,
                                item.endDate = data.endDate,
                                item.empId = personalInfo.employeeId;
                            item.file = data.file;
                        }
                        return item;
                    })
                    setUploadDocument(updatedData);
                } else {

                    setUploadDocument([...uploadDocument, model]);
                }
            }
        } else {
            if (uploadDocument.filter(doc => doc.rowIndex === event.node.rowIndex).length > 0) {
                const updatedData = uploadDocument.map((item) => {
                    if (item.rowIndex === event.node.rowIndex) {
                        item.eductionalAttainment = data.eductionalAttainment;
                        item.university = data.university;
                        item.documentType = data.documentType;
                        // item.expiryDate = data.expiryDate;
                        item.startDate = data.startDate,
                            item.endDate = data.endDate,
                            item.empId = personalInfo.employeeId;
                        item.file = data.file;
                    }
                    return item;
                })
                setUploadDocument(updatedData);
            } else {
                setUploadDocument([...uploadDocument, model]);
            }
        }

    }, [uploadDocument, personalInfo]);


    /*---------------------------------------------------------------------------------------------*/

    const handleSubmit = async () => {
        try {
            await Promise.all(uploadDocument.map(async (upload, index) => {
                try {
                    const formData = new FormData();
                    formData.append('File', upload.file);
                    const fileName = upload?.file?.name;
                    const uploadDocUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.uploadEductationDocument}?eductionalAttainment=${upload.eductionalAttainment}&university=${upload.university}&documentType=${upload.documentType}&expiryDate=${upload.expiryDate}&empId=${upload.empId}&uploadFile=${fileName}`
                    if (upload.file.length === 0) {
                        if (upload.id) {
                            const responce = await OAuthService.updateData(url, upload.id, upload);
                            if (responce.status === 200) {
                                setSuccessMsg("Update document successfully");
                                setSnackState(true);
                                setTimeout(() => { setSnackState(false) }, 1000);
                            }
                        }
                    } else {
                        if (upload.id) {
                            await OAuthService.deleteData(url, upload.id);
                        }
                        const responce = await OAuthService.uploadFile(uploadDocUrl, formData);
                        if (responce.status === 200) {
                            setSuccessMsg("Upload document successfully");
                            setSnackState(true);
                            setTimeout(() => { setSnackState(false) }, 1000);
                        }
                    }
                } catch (error) {
                    console.log('error', error);
                }
            }))
        } catch (error) {
            console.log(error);
        }
    }


    return (
        <div>
            <div className='flex justify-end mb-16'>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="warning"
                >
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                    Save Document
                </Button>
            </div>
            <div style={{ height: "500px" }}>

                <AgGridTable
                    columnDefs={educationColumnDefs}
                    rowData={educationInfo}
                    onGridReady={onGridReady}

                    //   onSelectionChanged={onSelectionChanged}
                    //   onRowDoubleClicked={onRowDoubleClicked}
                    gridRef={gridRef}
                    editable={true}
                    editType={'fullRow'}
                    paginationPageSize={10}
                    onRowValueChanged={onRowValueChanged}
                    getContextMenuItems={getContextMenuItems}
                    saveGridStateName={'eductionInfo'}
                />
            </div>
        </div>
    )
}

export default EductionDetail